/**
 * A function that does nothing
 */
export function noOp() {}
